import { styled } from '@mui/system';
import { Pagination, Button } from '@mui/material';
import PageBar from '#component/general/page-bar';

export const Root = styled('section')({
  display: 'flex',
  flexDirection: 'column'
});

export const Container = styled('div')(({ theme }) => ({
  padding: theme.spacing(1),
  margin: theme.spacing(3, 3, 2, 3),
  [theme.breakpoints.down('md')]: {
    margin: theme.spacing(2, 0, 0, 0)
  }
}));

export const LoadingContainer = styled('div')({
  height: '100%',
  minHeight: '100vh'
});

export const TextCenter = styled('div')({
  textAlign: 'center'
});

export const FilterButtonContainerSiteManager = styled('div')(({ theme }) => ({
  position: 'sticky',
  display: 'grid',
  gridTemplateColumns: 'auto 160px 170px 160px',
  gridTemplateAreas: '"filter addWarehouseBtn addApplianceBtn"',
  gridGap: theme.spacing(1),
  padding: theme.spacing(2, 4, 2, 4),
  width: '100%',
  backgroundColor: '#EEE',
  zIndex: 1100,
  [theme.breakpoints.down('md')]: {
    padding: theme.spacing(2, 1, 2, 1),
    gridTemplateColumns: 'auto 120px 160px'
  },
  [theme.breakpoints.down('sm')]: {
    display: 'flex',
    boxShadow: 'none',
    padding: '32px 8px 16px 8px'
  },
  '@media (max-width: 420px)': {
    gridTemplateColumns: 'auto'
  }
}));

export const FilterButtonContainerSiteManagerAddSite = styled(PageBar)(({ theme }) => ({
  position: 'sticky',
  display: 'grid',
  gridTemplateColumns: 'auto 160px 1px',
  gridTemplateAreas: '"filter addWarehouseBtn addApplianceBtn"',
  gridGap: theme.spacing(1),
  padding: theme.spacing(2, 4, 2, 4),
  width: '100%',
  backgroundColor: '#EEE',
  zIndex: 1100,
  [theme.breakpoints.down('md')]: {
    padding: theme.spacing(2, 1, 2, 1),
    gridTemplateColumns: 'auto 120px 1px'
  },
  [theme.breakpoints.down('sm')]: {
    display: 'flex',
    boxShadow: 'none',
    padding: '32px 8px 16px 8px'
  },
  '@media (max-width: 420px)': {
    gridTemplateColumns: 'auto'
  }
}));

export const AddWarehouseButton = styled(Button)({
  gridArea: 'addWarehouseBtn'
});

export const AddButtonLabel = styled('span')(({ theme }) => ({
  color: 'rgba(0, 0, 0, 0.87)',
  marginLeft: theme.spacing(0.5)
}));

export const StyledPagination = styled(Pagination)(({ theme }) => ({
  padding: theme.spacing(4, 0, 4, 0),
  '& > ul': {
    justifyContent: 'center'
  }
}));

export const CallToActionButton = styled(Button)({
  color: 'white',
  borderRadius: 7,
  position: 'absolute',
  margin: 'auto',
  top: 0,
  bottom: 0,
  left: 0,
  right: 0,
  height: 36,
  width: 190
});

export const MarginTopThree = styled('div')(({ theme }) => ({
  marginTop: theme.spacing(3)
}));

export const PaginationPlaceholder = styled('div')(({ theme }) => ({
  height: 1,
  margin: theme.spacing(2.5, 0, 2.5, 0)
}));

export const NoFilterData = styled('div')(({ theme }) => ({
  position: 'relative',
  minHeight: 'calc(100vh - 204px)',
  [theme.breakpoints.down('sm')]: {
    minHeight: 'calc(100vh - 296px)'
  }
}));

export const Loading = styled('div')(({ theme }) => ({
  filter: 'blur(5px)',
  position: 'relative',
  minHeight: 'calc(100vh - 204px)',
  [theme.breakpoints.down('xs')]: {
    minHeight: 'calc(100vh - 296px)'
  }
}));

export const Empty = styled('div')({
  minHeight: 'calc(100vh - 200px)',
  position: 'relative'
});

export const TabsSpacing = styled('span')({
  padding: '8px'
});
